<!--
 * @Author: wzh
 * @LastEditTime: 2023-06-09 18:18:02
 * @Description: 帮助文档 预览
-->
<template>
  <div class="h_doc">
    <a-tooltip :title="$t('login.help.download')">
      <a-icon type="download" class="down_btn" @click="handleDown" />
    </a-tooltip>

    <div ref="file"></div>
  </div>
</template>

<script>
import { unstrictFetch } from "@/apis/http";
import { renderAsync } from "docx-preview";

export default {
  name: "HelpDocument",
  data() {
    return {};
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      unstrictFetch({
        url: "setting/login/download",
        method: "get",
        responseType: "blob",
      }).then(({ data }) => {
        renderAsync(data, this.$refs.file);
      });
    },
    // 下载
    handleDown() {
      unstrictFetch({
        url: "setting/login/download",
        method: "get",
        responseType: "blob",
      }).then(({ data }) => {
        const blob = new Blob([data]); // 把得到的结果用流对象转一下
        var a = document.createElement("a"); //创建一个<a></a>标签
        a.href = URL.createObjectURL(blob); // 将流文件写入a标签的href属性值
        a.download = `${this.$t("login.help.filename")}.docx`; //设置文件名
        a.style.display = "none"; // 障眼法藏起来a标签
        document.body.appendChild(a); // 将a标签追加到文档对象中
        a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
        a.remove(); // 一次性的，用完就删除a标签
      });
    },
  },
};
</script>

<style lang="less" scoped>
.h_doc {
  .down_btn {
    position: fixed;
    top: 20px;
    right: 30px;
    color: #fff;
    font-size: 20px;
  }
}
</style>
